import { DataItemType, FormControlType } from "@cloudpivot/form/schema";
import schema from "./schema";
import conduct from "./conduct";
import design from "./components/design.vue";
import pc from "./components/pc.vue";
import mobile from "./components/mobile.vue";
const info = {
    title: "AI 润色",
    type: "ai-polish",
    icon: "",
    dataItemType: DataItemType.LongText,
    formControllerType: FormControlType.AI,
    group: "高级控件",
};
export default {
    info,
    schema,
    conduct,
    components: {
        design,
        pc,
        mobile,
    },
};
